import axios from 'axios';

import { config } from '@/config';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const axiosClient = axios.create({
  baseURL: config.site.api,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${localStorage.getItem(config.api.token)} `,
  },
});

export default axiosClient;
